export default "__VITE_ASSET__CICuapW9__"